import {
  EDIT_SOFTSKILL_ABILITY,
  EDIT_SOFTSKILL_ABILITY_SUCCESS,
  EDIT_SOFTSKILL_ABILITY_CLEAN,
  EDIT_SOFTSKILL_ABILITY_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  ability: undefined,
}

const SoftskillAbilityEdit = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_SOFTSKILL_ABILITY:
      state = {
        ...state,
        loading: true,
      }
      break
    case EDIT_SOFTSKILL_ABILITY_SUCCESS:
      state = {
        ...state,
        ability: action.payload.ability,
        loading: false,
        done: true,
      }
      break
    case EDIT_SOFTSKILL_ABILITY_CLEAN:
      state = initialState
      break
    case EDIT_SOFTSKILL_ABILITY_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SoftskillAbilityEdit
